import { useEffect } from 'react';
import { fetchImageSettingsProps } from './Constants';
import CaptureProfileService from 'business/services/CaptureProfileService';
import { RegionCaptureProfile } from 'business/models/Models';
import { getNewId } from 'utils/Global';
import { AnnotationPreference } from './AnnotationTools';
import { useRMDispatch } from 'redux/hooks';
import { setAnnotationPreference } from 'redux/reducers/experimentReducer';

export const useFetchImageSettings = (props: fetchImageSettingsProps) => {
  const {
    setCaptureImageSettings,
    setRegionCaptureProfiles,
    setIsUseAsExperiment,
    roiId,
    showModal,
  } = props;
  useEffect(() => {
    const fetchImageSettings = async () => {
      const captureProfileService = new CaptureProfileService();
      const imageSettings = await captureProfileService.getImageSettings();
      setCaptureImageSettings(imageSettings.captureProfilesDto);
      const regCaptureProfiles =
        await captureProfileService.getRegionCaptureProfilesByRegionId(roiId);
      setRegionCaptureProfiles(regCaptureProfiles);
      if (regCaptureProfiles.length === 0) {
        setIsUseAsExperiment(true);
        const regCaptureProfilesTemp: RegionCaptureProfile[] =
          imageSettings.captureProfilesDto?.map((rcp) => {
            const tempRCP = new RegionCaptureProfile();
            tempRCP.id = getNewId();
            tempRCP.captureProfileId = rcp.id;
            tempRCP.imagingEnabled = false;
            tempRCP.regionId = roiId;
            return tempRCP;
          });
        setRegionCaptureProfiles(regCaptureProfilesTemp);
      } else {
        setIsUseAsExperiment(false);
      }
    };

    if (roiId) {
      fetchImageSettings();
    }
  }, [roiId, showModal]);
};

export const useSetAnnotationPreference = () => {
  const dispatch = useRMDispatch();
  return (annotationPreference: AnnotationPreference) => {
    dispatch(setAnnotationPreference(annotationPreference));
  };
};
